import type { TDatadogErrorLog } from 'utils/datadog/types'

export const EDIT_DASHBOARD_FOLDER_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/edit-dashboard-folder-modal',
  name: 'Edits Dashboard Folder',
  message: 'Failed to edit the Dashboard Folder',
}
